import Vue from 'vue'
import master from '../masterModules/masterMutation.js'
// adminAccount-action
const URL = process.env.API_URL
const header = master.state.header

export default {
  inputUpdate(store, payload) {
    store.commit('inputUpdate', payload)
  },
  inputAddUpdate(store, payload) {
    store.commit('inputAddUpdate', payload)
  },
  clearAddUpdate(store) {
    store.commit('clearAddUpdate')
  },
  updateSelectedAccountList(store, payload) {
    store.commit('updateSelectedAccountList', payload)
  },
  clearSelectedAccountList(store) {
    store.commit('clearSelectedAccountList')
  },
  async addAdminAccount(store) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [store.state.addAdminAccount]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/adminuser/regist',
      data,
      config
    )
    // 成功
    // 追加後の処理
    store.commit('setAdminAccounts', response)
  },
  async setAdminAccounts(store, payload) {
    store.state.adminAccounts = []
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          pageNo: payload.pageNo,
          count: 20,
          searchWord: payload.searchWord
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/adminuser/list',
      data,
      config
    )

    if (payload.loginUserData[0] === '閲覧ユーザ') {
      var templist = []
      for (var i = 0; i < response.data['data'].length; i++) {
        if (
          response.data['data'][i]['adminUserId'] === payload.loginUserData[1]
        ) {
          templist = [response.data['data'][i]]
          break
        }
      }
      response.data['data'] = templist
    }
    // 成功
    store.commit('setAdminAccounts', response)
  },
  async updateAdminAccount(store) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [store.state.updateAdminAccount]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/adminuser/update',
      data,
      config
    )
    // 成功
    // 更新後の処理
    store.commit('setAdminAccounts', response)
  },
  async deleteAdminAccounts(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: payload
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/adminuser/delete',
      data,
      config
    )
    // 成功
    // 削除後の処理
    store.commit('setAdminAccounts', response)
  },
  async setDetailAdminAccount(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          adminUserId: payload.adminUserId
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/adminuser/detail',
      data,
      config
    )
    // 成功
    store.commit('setDetail', response)
  },
  async changePassword(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          userId: store.state.adminAccount.adminUserId,
          previousPassword: payload.previousPassword,
          newPassword: payload.newPassword,
          editTarget: 0
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/adminuser/password',
      data,
      config
    )
    // 成功
    store.commit('getDetail', response)
  },
  async importAdminAccounts(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          mode: '0',
          adminUsers: payload
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/System/Maintenance',
      data,
      config
    )
    // 成功
    // 追加後の処理
    store.commit('setAdminAccounts', response)
  },
  async setExportData(store, payload) {
    let logContinue = true
    let pageNo = 0
    const count = 3000
    const margeData = {
      data: {
        header: {},
        data: []
      }
    }
    let totalCount = 0
    while (logContinue) {
      const config = {
        headers: {
          Authorization: master.state.authorization
        },
        timeout: 1000 * 300
      }
      const data = {
        header,
        data: payload.selectedAccountIdList.slice(
          pageNo * count,
          pageNo * count + count
        ),
        pageNo: payload.selectedAccountIdList.length === 0 ? pageNo : 0,
        count: count,
        searchWord: payload.searchWord
      }
      var response = await Vue.http.post(
        URL + '/v2/admin/adminuser/export',
        data,
        config
      )

      const size = response.data['data'].length
      totalCount += size
      for (let i = 0; i < size; i++) {
        margeData.data.data.push(response.data['data'][i])
      }
      pageNo++
      if (size < count) {
        margeData.data.header = response.data['header']
        logContinue = false
      }
      if (
        payload.selectedAccountIdList.length > 0 &&
        totalCount >= payload.selectedAccountIdList.length
      ) {
        margeData.data.header = response.data['header']
        logContinue = false
      }
    }

    // 成功
    // 追加後の処理
    store.commit('setExportData', margeData)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/adminAccountModules/actions.js